import React from 'react'
import character from '@/images/jr_character.svg';
import dot from '@/images/dot.svg';
import { SendEmail } from 'util/email';
import '@/sass/home.scss';

interface IState {
    name: string,
    job: string,
    description: string,
    btnText: string
}

class Home extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props)
        this.state = {
            name: "James Riady",
            job: "Full-stack Web Developer",
            description: "who turns code into simple and scalable engineering service for your apps.",
            btnText: "Say Hi!"
        }
    }

    render() {
        return (
            <div id="home" className="home">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="introduction-container col-md-6">
                            <h1 className="greeting">Hi, I'm <span>{this.state.name}</span></h1>
                            <div className="description-container">
                                A <span className="job">{this.state.job}</span> {this.state.description}
                            </div>
                            <div className="btn-container">
                                <button onClick={SendEmail} className="btn btn-lg btn-custom">{this.state.btnText}</button>
                            </div>
                        </div>
                        <div className="character-container col-md-6">
                            <img src={character} className="character" alt="James Riady - Software Engineer"/>
                            <div className="dot-container">
                                <img src={dot} alt="small dot" />
                                <img src={dot} alt="medium dot" />
                                <img src={dot} alt="large dot" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home